module.exports = __webpack_public_path__ + "img/buzzloading2.1b77a225.svg";